import React from "react"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "./ChartDynamicColor";

const ApexLine = ({ dataColors, result, title, indicatorName, categories, minValue, maxValue }: any) => {
  const apaexlineChartColors = getChartColorsArray(dataColors);
  const categoriess = categories || ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
  const categoriesDt = categoriess.map((date) => {
    return new Date(date).toLocaleDateString('default', { day: '2-digit', month: '2-digit', year: 'numeric' });
  });
  const series = (result || [0]).map((item) => ({
    name: item?.name || "Unknown",
    data: Array.isArray(item.data) && item.data.length > 0 ? item.data[0] : [0]
  }));

  console.log('categoriesDt', categoriesDt)
  const options: any = {
    chart: {
      height: 400,  // Adjusted height
      type: 'line',
      zoom: { enabled: false },
      dropShadow: {
        enabled: true,
        color: '#d1cece',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.5,
      },
    },
    colors: ['#007bff', '#ff9800'], // Blue and Orange
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px',
      },
    },
    stroke: {
      width: [4, 4],
      curve: 'smooth',
    },
    title: {
      text: title,
      align: 'left',
      style: {
        fontWeight: 'bold',
      },
    },
    grid: {
      row: {
        colors: ['transparent', 'transparent'],
        opacity: 0.2,
      },
      borderColor: '#f1f1f1',
    },
    markers: {
      size: 4,
      opacity: 1,
      strokeWidth: 0,
      hover: { size: 7 }
    },
    xaxis: {
      type: 'category',
      labels: {
        show: true, // Set to true to always show x-axis labels
        // Adjust rotation
        hideOverlappingLabels: false, // Show overlapping labels
        style: {
          fontSize: '14px',
          colors: ['#ff5733'], // Color of labels
        },
        rotate: -45,
        rotateAlways: true,
      },
      title: {
        text: 'Огноо',
        style: {
          color: '#ff5733', // X тэвшний нэрний өнгө
        },
      },
      // tooltip: { enabled: true },
      axisBorder: {
        show: true,
        color: '#007bff',  // Border color
      },
      axisTicks: {
        show: true,
        color: '#78909C',
        height: 6,
      },
      crosshairs: { stroke: { color: '#78909C' } },
      categories: categoriesDt,

    },
    yaxis: {
      title: {
        text: 'Тоо',  // Y тэвшний нэр
        style: {
          color: '#212529',  // Y тэвшний нэрний өнгө
          fontSize: '14px',   // Хэмжээ тохируулах
          fontWeight: 'bold', // Тохиромжтой хүнд, тод шрифт
        },
      },
      min: minValue,
      max: maxValue,
      tickAmount: 5,
      axisBorder: {
        show: true,
        color: '#007bff',  // Border color
      },
      axisTicks: {
        show: true,
        color: '#78909C',
        height: 6,
      },
    },
    tooltip: { x: { format: 'YY-MM-dd  ' } },

    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5,
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: {
          height: 350,
        },
        xaxis: {
          labels: {
            rotate: -30, // Rotate more on small screens
          },
        },
      },
    }],
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      height="380"
      className="apex-charts"
    // width='100%'
    />
  );
}

export default ApexLine
